<div class="container">
    <pdf-viewer [src]="pdfFilePath"
                [render-text]="true"
                style="display: block;"
    ></pdf-viewer>
</div>
